import { useRef, useState } from "react";
import { FolderOpen, Paperclip, Upload } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { FilePickerDialog } from "@/components/files/FilePickerDialog";
import { ACCEPT } from "@/lib/files";

export function AttachMenu({ uploads, testIdPrefix }) {
  const inputRef = useRef(null);
  const [picking, setPicking] = useState(false);
  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={ACCEPT}
        className="hidden"
        data-testid={`${testIdPrefix}-file-input`}
        onChange={(e) => {
          uploads.addFiles(e.target.files);
          e.target.value = "";
        }}
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button type="button" aria-label="Attach files" data-testid={`${testIdPrefix}-attach-button`} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-zinc-400 transition-colors hover:bg-white/[0.06] hover:text-white">
            <Paperclip className="h-[18px] w-[18px]" strokeWidth={1.6} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" side="top" className="w-56 border-white/10 bg-ink-850">
          <DropdownMenuItem onSelect={() => inputRef.current?.click()} className="gap-2.5 focus:bg-white/[0.06]" data-testid={`${testIdPrefix}-attach-upload`}>
            <Upload className="h-4 w-4" /> Upload from device
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setPicking(true)} className="gap-2.5 focus:bg-white/[0.06]" data-testid={`${testIdPrefix}-attach-existing`}>
            <FolderOpen className="h-4 w-4" /> Choose from your files
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <FilePickerDialog open={picking} onOpenChange={setPicking} onPick={uploads.addExisting} excludeIds={uploads.items.map((i) => i.id).filter(Boolean)} />
    </>
  );
}
